"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const Button = (props) => {
    const { loading = false, variant, size, startIcon, fullWidth = false, sx = {}, ...rest } = props;
    const loadingStyles = loading
        ? {
            height: size === "small" ? "35px !important" : "50px !important",
            width: size === "small" ? "35px !important" : "50px !important",
            p: "0 !important",
            transition: "width 0.4s ease-in",
            ".MuiButton-startIcon": {
                display: "none",
            },
        }
        : {};
    const component = (react_1.default.createElement(material_1.Button, { "data-testid": "button", sx: {
            transition: "width 0.4s ease-out",
            ...sx,
            ...loadingStyles,
        }, variant: variant, startIcon: startIcon, fullWidth: fullWidth, size: size, ...rest }, loading ? (react_1.default.createElement(material_1.CircularProgress, { "data-cy": "progressbar-loading", color: variant === "contained" ? "secondary" : "primary", size: size === "small" ? 16 : 25 })) : (props.children)));
    return fullWidth ? (react_1.default.createElement(material_1.Box, { sx: { width: "100%", display: "flex", justifyContent: "center" } }, component)) : (component);
};
exports.default = Button;
